import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './FandOOpt.css';
import { useNavigate } from "react-router-dom";

function FandOOpt(props) {
    const [optionType, setOptionType] = useState('');
    const [optionFuture, setOptionFuture] = useState('');
    const [optionOpt, setOptionOpt] = useState('');
    let getOptionValue = props.optionValue;
    let navigate = useNavigate();

    useEffect(() => {
        if (optionOpt === "Overview") {
            navigate("/market/futures-and-options");
        }
        if (optionOpt === "Most Active Call") {
            navigate("/Futures-And-Options/Most-Active-Call");
        }
        if (optionOpt === "Most Active Put") {
            navigate("/Futures-And-Options/Most-Active-Put");
        }
        if (optionOpt === "Top Gainers (Options)") {
            navigate("/Futures-And-Options/Top-Gainers-Options");
        }
        if (optionOpt === "Top Losers (Options)") {
            navigate("/Futures-And-Options/Top-Losers-Options");
        }
        if (optionOpt === "Highest in OI (Options)") {
            navigate("/Futures-And-Options/Highest-in-OI-Options");
        }
        if (optionOpt === "Lowest in OI (Options)") {
            navigate("/Futures-And-Options/Lowest-in-OI-Options");
        }
        if (optionOpt === "Increase in OI in % (Options)") {
            navigate("/Futures-And-Options/Increase-in-OI-Options");
        }
        if (optionOpt === "Decrease in OI in % (Options)") {
            navigate("/Futures-And-Options/Decrease-in-OI-Options");
        }
        if (optionOpt === "Option Chain") {
            navigate("/Futures-And-Options/Option-Chain");
        }
    }, [optionOpt]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-sc'>
                            <div className='market-inner'>
                                <div className='market-selectFut'>
                                    <select value={getOptionValue} onChange={(event) => { setOptionOpt(event.target.value) }}>
                                        <option value="Overview">Overview</option>
                                        <option value="Most Active Call">Most Active Call</option>
                                        <option value="Most Active Put">Most Active Put</option>
                                        <option value="Option Chain">Option Chain</option>
                                        <option value="Top Gainers (Options)">Top Gainers (Options)</option>
                                        <option value="Top Losers (Options)">Top Losers (Options)</option>
                                        <option value="Highest in OI (Options)">Highest in OI (Options)</option>
                                        <option value="Lowest in OI (Options)">Lowest in OI (Options)</option>
                                        <option value="Increase in OI in % (Options)">Increase in OI in % (Options)</option>
                                        <option value="Decrease in OI in % (Options)">Decrease in OI in % (Options)</option>
                                    </select>
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default FandOOpt;